<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques" :showIsAssign="true">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}日期題
    </template>
    <v-card-text class="text-start " slot="content">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx" class="blod quest_topic">{{ name }}</div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>

      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="ques.value"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="ques.value"
            prepend-icon="event"
            readonly
            v-on="on"
            class="peter-text"
            :rules="[
              v => {
                let pass = !(ques.isRequired && !ques.value)
                return pass ? true : '此題為必填'
              }
            ]"
          ></v-text-field>
        </template>
        <v-date-picker v-model="ques.value" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(ques.value)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      modal: false
    }
  }
}
</script>

<style lang="scss" scoped></style>
